export const yandexSource = '219:99f3dabd-c202-4c49-a9ab-77905c134390';
export const naukotekaSource = '219:3214a64b-8d67-48d3-af21-8ca22f73137e';
export const nakedSource = '219:5a080618-4065-4f41-900a-35fdcb9cd395';
